
export default {

    /**
     * Tất cả
     */
    All: 0,

    /**
     * Đã đọc
     */
    Read: 1,

    /**
     * Chưa đọc
     */
    Unread: 2
};
